import Swiper, { A11y, Pagination } from 'swiper'

const StoryBlock = {
  init() {
    document.querySelectorAll<HTMLElement>('[data-story-block]').forEach((block) => {
      const previousButtons = block.querySelectorAll<HTMLButtonElement>('[data-story-block-previous]')
      const nextButtons = block.querySelectorAll<HTMLButtonElement>('[data-story-block-next]')
      const pagination = block.querySelector<HTMLElement>('[data-swiper-pagination]')

      if (!previousButtons.length || !nextButtons.length || !pagination) return

      const updateNavigation = (swiper: Swiper) => {
        previousButtons.forEach((button) => {
          button.disabled = swiper.isBeginning
        })

        nextButtons.forEach((button) => {
          button.disabled = swiper.isEnd
        })
      }

      const swiper = new Swiper(block, {
        modules: [A11y, Pagination],
        a11y: {
          containerMessage: 'Stories',
          slideLabelMessage: '{{index}} of {{slidesLength}}',
        },
        allowTouchMove: false,
        autoHeight: true,
        simulateTouch: false,
        resizeObserver: false,
        slidesPerView: 1,
        pagination: {
          el: pagination,
          clickable: true,
          bulletElement: 'button',
          renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Go to story ${index + 1}"></button>`,
        },
        on: {
          afterInit: updateNavigation,
          slideChange: updateNavigation,
        },
      })

      previousButtons.forEach((button) => {
        button.addEventListener('click', () => swiper.slidePrev())
      })

      nextButtons.forEach((button) => {
        button.addEventListener('click', () => swiper.slideNext())
      })
    })
  },
}

export default StoryBlock
